import { render, staticRenderFns } from "./LkReferals.vue?vue&type=template&id=1d5e7b1c&scoped=true&"
import script from "./LkReferals.vue?vue&type=script&lang=js&"
export * from "./LkReferals.vue?vue&type=script&lang=js&"
import style0 from "./LkReferals.vue?vue&type=style&index=0&id=1d5e7b1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5e7b1c",
  null
  
)

export default component.exports